import { createAction } from "@reduxjs/toolkit";
import { AddCartItemAPIPayload, ProductsApiPayload, RemoveCartItemAPIPayload, TopProductsApiPayload } from "./types";
export const productListingApi = createAction<ProductsApiPayload>("productListingApi");
export const topProductListingApi = createAction<TopProductsApiPayload>("topProductsApi");
export const itemInCartList = createAction<ProductsApiPayload>("itemInCartList");
export const resetProductListingPagination = createAction("resetProductListingPagination");
export const itemInCartUpdate = createAction("itemInCartUpdate");
export const addCartItemApi = createAction<AddCartItemAPIPayload>("addCartItemApi");
export const deleteCartItemApi = createAction<RemoveCartItemAPIPayload>("deleteCartItemApi");
export const updateCheckAllItem = createAction<boolean>("updateCheckAllItem");
export const getCartItemApi = createAction("getCartItemApi");
